import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import AuthTemplate from '@/components/layout/AuthTemplate';
import PublicTemplate from '@/components/layout/PublicTemplate';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { store } from '@/store';

import DashboardWrapper from '@/pages/DashboardWrapper';
import DashboardOAuthCallback from '@/pages/DashboardOAuthCallback';
import AnalyticsPropertySelector from '@/pages/AnalyticsPropertySelector';
import Analytics from '@/pages/Analytics';
import Users from '@/pages/Users';
import Scout from '@/pages/Scout';
import ResearchHome from '@/pages/ResearchHome';
import ResearchDetails from '@/pages/ResearchDetails';
import Cluster from '@/pages/Cluster';
import Settings from '@/pages/Settings/index';
import Reports from '@/pages/Reports/index';
import GenerateReport from '@/pages/Reports/Generate';
import AIAudit from '@/pages/AIAudit/index';
import Login from '@/pages/Auth/Login';
import Register from '@/pages/Auth/Register';
import ForgotPassword from '@/pages/Auth/ForgotPassword';
import ResetPassword from '@/pages/Auth/ResetPassword';
import AppSumoOnboarding from '@/pages/Auth/AppSumoOnboarding';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <Router>
        <Routes>
        {/* Public Routes - No authentication required */}
        <Route path="/login" element={<PublicTemplate />}>
          <Route 
            index 
            element={
              <ProtectedRoute requireAuth={false}>
                <Login />
              </ProtectedRoute>
            } 
          />
        </Route>

        <Route path="/register" element={<PublicTemplate />}>
          <Route 
            index 
            element={
              <ProtectedRoute requireAuth={false}>
                <Register />
              </ProtectedRoute>
            } 
          />
        </Route>

        <Route path="/forgot-password" element={<PublicTemplate />}>
          <Route 
            index 
            element={
              <ProtectedRoute requireAuth={false}>
                <ForgotPassword />
              </ProtectedRoute>
            } 
          />
        </Route>

        <Route path="/reset-password" element={<PublicTemplate />}>
          <Route 
            index 
            element={
              <ProtectedRoute requireAuth={false}>
                <ResetPassword />
              </ProtectedRoute>
            } 
          />
        </Route>

        <Route path="/appsumo/onboarding" element={<PublicTemplate />}>
          <Route 
            index 
            element={
              <ProtectedRoute requireAuth={false}>
                <AppSumoOnboarding />
              </ProtectedRoute>
            } 
          />
        </Route>

        {/* Protected Routes - Authentication required (at root level) */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute requireAuth={true}>
              <AuthTemplate />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardWrapper />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="analytics/properties" element={<AnalyticsPropertySelector />} />
          <Route path="dashboard/oauth-callback" element={<DashboardOAuthCallback />} />
          <Route path="users" element={<Users />} />
          <Route path="scout" element={<Scout />} />
          <Route path="research" element={<ResearchHome />} />
          <Route path="research/:id" element={<ResearchDetails />} />
          <Route path="cluster" element={<Cluster />} />
          <Route path="reports" element={<Reports />} />
          <Route path="reports/generate" element={<GenerateReport />} />
          <Route path="reports/:id" element={<Reports />} />
          <Route path="ai-audit" element={<AIAudit />} />
          <Route path="ai-audit/:auditId" element={<AIAudit />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
